<template>
  <v-form
    v-if="loaded"
    ref="form">
    <tab-title
      :car-id="appointment.car.id"
      text="セールスポイント" />
    <cp-radio
      :value="carFields.PUSH_STRT"
      :items="yesOrNo"
      :rules="[$rules.isRequired]"
      label="プッシュスタート *"
      data-label-scroll="PUSH_STRT"
      @change="value => updateSalesPoints('PUSH_STRT', value)" />
    <cp-radio
      :value="carFields.KEYLESS"
      :items="yesOrNo"
      :rules="[$rules.isRequired]"
      label="キーレス *"
      data-label-scroll="KEYLESS"
      @change="value => updateSalesPoints('KEYLESS', value)" />
    <cp-radio
      :value="carFields.CAMERA_360"
      :items="yesOrNo"
      :rules="[$rules.isRequired]"
      label="360（全方位）カメラ *"
      data-label-scroll="CAMERA_360"
      @change="value => updateSalesPoints('CAMERA_360', value)" />
    <cp-radio
      v-if="carFields.CAMERA_360 && carFields.CAMERA_360 !== 'NO'"
      :value="carFields.CAMERA_360_MOVEMENT_CONFIRM"
      :items="detailsBasic"
      :rules="[$rules.isRequired]"
      label="動作確認（カメラ) *"
      data-label-scroll="CAMERA_360_MOVEMENT_CONFIRM"
      @change="value => updateSalesPoints('CAMERA_360_MOVEMENT_CONFIRM', value)" />
    <v-text-field
      v-if="carFields.CAMERA_360 && carFields.CAMERA_360 !== 'NO'
      && carFields.CAMERA_360_MOVEMENT_CONFIRM === 'FAULT'"
      :value="carFields.CAMERA_360_MOVEMENT_CONFIRM_DESCRIPTION"
      :rules="[$rules.isRequired]"
      label="具体的に(カメラ) *"
      data-label-scroll="CAMERA_360_MOVEMENT_CONFIRM_DESCRIPTION"
      @blur="({ target }) => updateSalesPoints(
      'CAMERA_360_MOVEMENT_CONFIRM_DESCRIPTION', target.value)"
    />
    <cp-radio-confirm-desc
      v-if="carFields.CAMERA_360 === 'NO'"
      :value="carFields.CAMERA_BACK"
      :confirm-value="carFields.CAMERA_BACK_MOVEMENT_CONFIRM"
      :description="carFields.CAMERA_BACK_MOVEMENT_CONFIRM_DESCRIPTION"
      :update-item="updateSalesPoints"
      name="CAMERA_BACK"
      label="バックカメラ"
      data-label-scroll="CAMERA_BACK"
      @change="(value) => updateSalesPoints('CAMERA_BACK', value)"
    />
    <cp-radio-confirm-desc
      v-if="carFields.CAMERA_360 === 'NO'"
      :value="carFields.CAMERA_FRONT"
      :confirm-value="carFields.CAMERA_FRONT_MOVEMENT_CONFIRM"
      :description="carFields.CAMERA_FRONT_MOVEMENT_CONFIRM_DESCRIPTION"
      :update-item="updateSalesPoints"
      name="CAMERA_FRONT"
      label="フロントカメラ"
      data-label-scroll="CAMERA_FRONT"
      @change="(value) => updateSalesPoints('CAMERA_FRONT', value)"
    />
    <cp-radio-confirm-desc
      v-if="carFields.CAMERA_360 === 'NO'"
      :value="carFields.CAMERA_SIDE"
      :confirm-value="carFields.CAMERA_SIDE_MOVEMENT_CONFIRM"
      :description="carFields.CAMERA_SIDE_MOVEMENT_CONFIRM_DESCRIPTION"
      :update-item="updateSalesPoints"
      name="CAMERA_SIDE"
      label="サイドカメラ"
      data-label-scroll="CAMERA_SIDE"
      @change="(value) => updateSalesPoints('CAMERA_SIDE', value)"
    />
    <cp-radio-confirm-desc
      :value="carFields.FLIP_DOWN_MONITOR"
      :confirm-value="carFields.FLIP_DOWN_MONITOR_MOVEMENT_CONFIRM"
      :description="carFields.FLIP_DOWN_MONITOR_MOVEMENT_CONFIRM_DESCRIPTION"
      :update-item="updateSalesPoints"
      name="FLIP_DOWN_MONITOR"
      label="フリップダウンモニター"
      data-label-scroll="FLIP_DOWN_MONITOR"
      @change="(value) => updateSalesPoints('FLIP_DOWN_MONITOR', value)"
    />
    <cp-radio-confirm-desc
      :value="carFields.POWER_BACK_DOOR"
      :confirm-value="carFields.POWER_BACK_DOOR_MOVEMENT_CONFIRM"
      :description="carFields.POWER_BACK_DOOR_MOVEMENT_CONFIRM_DESCRIPTION"
      :update-item="updateSalesPoints"
      name="POWER_BACK_DOOR"
      label="パワーバックドア"
      data-label-scroll="POWER_BACK_DOOR"
      @change="(value) => updateSalesPoints('POWER_BACK_DOOR', value)"
    />
    <cp-radio
      :value="carFields.SLIDING_DOORS"
      :items="slidingDoorsOptions"
      :rules="[$rules.isRequired]"
      label="パワースライドドア *"
      data-label-scroll="SLIDING_DOORS"
      @change="value => updateSalesPoints('SLIDING_DOORS', value)" />
    <cp-radio
      v-if="carFields.SLIDING_DOORS && carFields.SLIDING_DOORS !== 'NONE'"
      :value="carFields.SLIDING_DOORS_MOVEMENT_CONFIRM"
      :items="detailsBasic"
      :rules="[$rules.isRequired]"
      label="動作確認 *"
      data-label-scroll="SLIDING_DOORS_MOVEMENT_CONFIRM"
      @change="value => updateSalesPoints('SLIDING_DOORS_MOVEMENT_CONFIRM', value)" />
    <v-text-field
      v-if="carFields.SLIDING_DOORS && carFields.SLIDING_DOORS_MOVEMENT_CONFIRM === 'FAULT'"
      :value="carFields.SLIDING_DOORS_MOVEMENT_CONFIRM_DESCRIPTION"
      :rules="[$rules.isRequired]"
      label="具体的に *"
      data-label-scroll="SLIDING_DOORS_MOVEMENT_CONFIRM_DESCRIPTION"
      @blur="({ target }) => updateSalesPoints(
      'SLIDING_DOORS_MOVEMENT_CONFIRM_DESCRIPTION', target.value)" />
    <v-select
      :value="carFields.POWER_SEAT"
      :items="powerSeatOptions"
      :rules="[$rules.isRequired]"
      label="パワーシート *"
      data-label-scroll="POWER_SEAT"
      @change="(val) => updateSalesPoints('POWER_SEAT', val)" />
    <cp-radio
      v-if="carFields.POWER_SEAT && carFields.POWER_SEAT !== 'NONE'"
      :value="carFields.POWER_SEAT_MOVEMENT_CONFIRM"
      :items="detailsBasic"
      :rules="[$rules.isRequired]"
      label="動作確認 *"
      data-label-scroll="POWER_SEAT_MOVEMENT_CONFIRM"
      @change="value => updateSalesPoints('POWER_SEAT_MOVEMENT_CONFIRM', value)" />
    <v-text-field
      v-if="carFields.POWER_SEAT_MOVEMENT_CONFIRM === 'FAULT'"
      :value="carFields.POWER_SEAT_MOVEMENT_CONFIRM_DESCRIPTION"
      :rules="[$rules.isRequired]"
      label="具体的に *"
      data-label-scroll="POWER_SEAT_MOVEMENT_CONFIRM_DESCRIPTION"
      @blur="({ target }) => updateSalesPoints(
      'POWER_SEAT_MOVEMENT_CONFIRM_DESCRIPTION', target.value)" />
    <v-select
      :value="carFields.SEAT_HEATER"
      :items="powerSeatOptions"
      :rules="[$rules.isRequired]"
      label="シートヒーター *"
      data-label-scroll="SEAT_HEATER"
      @change="(val) => updateSalesPoints('SEAT_HEATER', val)" />
    <cp-radio
      v-if="carFields.SEAT_HEATER && carFields.SEAT_HEATER !== 'NONE'"
      :value="carFields.SEAT_HEATER_MOVEMENT_CONFIRM"
      :items="detailsBasic"
      :rules="[$rules.isRequired]"
      label="動作確認 *"
      data-label-scroll="SEAT_HEATER_MOVEMENT_CONFIRM"
      @change="value => updateSalesPoints(
      'SEAT_HEATER_MOVEMENT_CONFIRM', value)" />
    <v-text-field
      v-if="carFields.SEAT_HEATER_MOVEMENT_CONFIRM === 'FAULT'"
      :value="carFields.SEAT_HEATER_MOVEMENT_CONFIRM_DESCRIPTION"
      :rules="[$rules.isRequired]"
      label="具体的に *"
      data-label-scroll="SEAT_HEATER_MOVEMENT_CONFIRM_DESCRIPTION"
      @blur="({ target }) => updateSalesPoints(
      'SEAT_HEATER_MOVEMENT_CONFIRM_DESCRIPTION', target.value)" />
    <cp-radio
      v-model="appointment.car.ptsOwners"
      :items="yesOrNoBool"
      :rules="[$rules.isRequired]"
      label="ワンオーナー *"
      data-label-scroll="ptsOwners"
      @change="value => updateCar({ field: 'ptsOwners', value })" />
    <v-textarea
      :value="carFields.OTHERS"
      label="その他セールスポイント"
      data-label-scroll="OTHERS"
      @blur="({ target }) => updateSalesPoints('OTHERS', target.value)" />
    <v-divider class="my-5" />
    <v-btn
      outline
      color="info"
      block
      large
      to="photos#top">次へ</v-btn>
  </v-form>
</template>

<script>
import { GET_CAR_FIELDS, getCarWith } from '../../queries';
import {
  yesOrNo,
  slidingDoorsOptions,
  yesOrNoBool,
  powerSeatOptions,
  detailsBasic,
  yesOrNoString,
} from '../../options';

const defaultCarFields = [
  'PUSH_STRT',
  'KEYLESS',
  'CAMERA_360',
  'CAMERA_360_MOVEMENT_CONFIRM',
  'CAMERA_360_MOVEMENT_CONFIRM_DESCRIPTION',
  'CAMERA_BACK',
  'CAMERA_BACK_MOVEMENT_CONFIRM',
  'CAMERA_FRONT',
  'CAMERA_FRONT_MOVEMENT_CONFIRM',
  'CAMERA_SIDE',
  'CAMERA_SIDE_MOVEMENT_CONFIRM',
  'FLIP_DOWN_MONITOR',
  'FLIP_DOWN_MONITOR_MOVEMENT_CONFIRM',
  'POWER_BACK_DOOR',
  'POWER_BACK_DOOR_MOVEMENT_CONFIRM',
  'SLIDING_DOORS',
  'SLIDING_DOORS_MOVEMENT_CONFIRM',
  'SLIDING_DOORS_MOVEMENT_CONFIRM_DESCRIPTION',
  'POWER_SEAT',
  'POWER_SEAT_MOVEMENT_CONFIRM',
  'POWER_SEAT_MOVEMENT_CONFIRM_DESCRIPTION',
  'SEAT_HEATER',
  'SEAT_HEATER_MOVEMENT_CONFIRM',
  'SEAT_HEATER_MOVEMENT_CONFIRM_DESCRIPTION',
  'OTHERS',
];

export default {
  props: {
    appointmentId: {
      type: [String, Number],
      default: '',
    },
  },
  apollo: {
    carFields: {
      query: GET_CAR_FIELDS,
      fetchPolicy: 'network-only',
      skip() {
        return !this.appointment || !this.appointment.car.id;
      },
      variables() {
        return {
          carId: this.appointment.car.id,
        };
      },
      update({ carFields }) {
        this.loaded = true;
        return {
          ...defaultCarFields,
          ...carFields.data.reduce((acc, cur) => ({
            ...acc,
            [cur.code]: cur.value,
          }), {}),
        };
      },
    },
    appointment: {
      query: getCarWith(['ptsOwners']),
      fetchPolicy: 'network-only',
      variables() {
        return { id: parseInt(this.$route.params.id, 10) };
      },
      result() {
        this.$apollo.queries.carFields.refetch();
      },
    },
  },
  data() {
    return {
      yesOrNo,
      slidingDoorsOptions,
      powerSeatOptions,
      yesOrNoBool,
      detailsBasic,
      yesOrNoString,
      carFields: defaultCarFields,
      loaded: false,
    };
  },
  methods: {
    updateSalesPoints(code, value) {
      return this.updateField({
        code,
        value,
        carId: this.appointment.car.id,
        typeId: 80,
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/tabs/SalesPointsTab.vue